
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Badge from 'vux/src/components/badge/index.vue'

import footnav from '@/views/components/footnav'
import defautphoto from '@/assets/timg.jpg'
import config from '@/config'
import { getUserAccount } from '@/api/user.js'
import { myDeal } from '@/api/youzheng.js'
import addressPicker from '@/views/components/address-picker'
import { isWorker, getDealList } from '@/api/zhigongxiaojia.js'
import { isWorker as ismamiWorker, getDealList as getmamiDealList } from '@/api/mamixiaowu.js'
export default {
name: 'userinfo',
components: {
Group,
Cell,
footnav,
addressPicker,
Badge
},
data () {
return {
defautphoto: defautphoto,
baseUrl: config.baseUrl,
photo: '',
showMore: false,
personObj: {},
integral: '',
address: '',
birthday: '',
addressValue: [],
accounttype: this.$store.state.user.personObj.accounttype,
idtype: 2,
total: 0,
area: ''
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
methods: {
getmyDeal () {
if (this.accounttype === 4) {
this.idtype == 1
}
myDeal({
accountid: this.accountid,
idtype: this.idtype,
userid: this.userid
}).then(res => {
this.total = res.obj.total

})
},
getUserMessage () {
getUserAccount({
accountid: this.accountid
}).then(res => {
if (res.status === 'suc') {
this.personObj = res.returnValue
this.photo = res.returnValue.iconimgPATH
}
})
},
goEdit () {
this.$router.push({ path: '/userinfo/edit' })

},
cleardata () {
localStorage.clear()
this.$vux.alert.show({
content: '清除本地缓存成功',
onHide () {
window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + config.appid + '&redirect_uri=' + config.baseDeaultUrl + '/&response_type=code&scope=snsapi_base&state=200&connect_redirect=1#wechat_redirect'
}
})
}










































},
created () {

this.personObj = this.$store.state.user.personObj
let unitname = this.personObj.unitname
let areaList = ['杭州', '宁波', '温州', '嘉兴', '湖州', '绍兴', '金华', '衢州', '丽水', '台州', '舟山']
areaList.forEach(item => {
if (unitname.indexOf(item) > -1) {
this.area = item
} else {
this.area = '直属'
}
})
this.photo = this.$store.state.user.personObj.iconimgPATH
this.getmyDeal()
},
mounted () { }
}
